import { Container } from '@/components/Container/Container';
import { ESize } from '@/models/enums';
import { Button } from '@netfront/ui-library';

type CtaBannerProps = {
  label: string;
  heading: string;
  description: string;
  button: {
    id: string;
    url: string;
    text: string;
  };
};

export const CtaBanner = ({ label, heading, description, button }: CtaBannerProps) => {
  return (
    <div className="bg-primary py-12">
      <Container size={ESize.MD}>
        <div className="flex flex-col lg:flex-row lg:items-center gap-6">
          <div className="flex-1">
            <p className="text-uppercase text-xs font-bold color-white mb-1" style={{ opacity: 0.7, letterSpacing: '0.05em' }}>
              {label}
            </p>
            <h2 className="color-white mb-2">{heading}</h2>
            <p className="color-white mb-0" style={{ opacity: 0.85 }}>
              {description}
            </p>
          </div>
          <Button
            additionalClassNames="shrink-0"
            linkButton={{ id: button.id, url: button.url }}
            text={button.text}
            variant="secondary"
          />
        </div>
      </Container>
    </div>
  );
};
